import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import elementsActions from 'actions/editor/elements';
import AddNewElement from '../add_element';
import DropTarget from './dropTarget';

const mapDispatchToProps = dispatch => ({
  onCreate(type, position) {
    dispatch(elementsActions.create(type, position));
  },
});

const ElementAdder = compose(
  connect(null, mapDispatchToProps),
  DropTarget,
)(AddNewElement);

export const createAdder = position => (
  <ElementAdder position={position} key={'add_' + position} />
);

export default ElementAdder;
